import React from 'react';
import { motion } from 'framer-motion';
import { ConfidenceBar } from './ConfidenceBar';
import { useSessionStore } from '../../store/sessionStore';
import { SIGN_DISPLAY_TEXT } from '../../constants/signDisplayText';

export const CurrentSignCard: React.FC = () => {
  const { currentSign } = useSessionStore();
  const displayText = currentSign ? (SIGN_DISPLAY_TEXT[currentSign.label] ?? currentSign.label) : null;
  const pct = currentSign ? Math.round(currentSign.confidence * 100) : 0;
  const isHigh = pct >= 85;

  return (
    <div
      className="rounded-2xl p-4 flex-shrink-0"
      style={{
        background: 'rgba(13,23,48,0.7)',
        border: currentSign
          ? `1px solid ${isHigh ? 'rgba(45,212,191,0.35)' : 'rgba(14,165,233,0.25)'}`
          : '1px solid rgba(255,255,255,0.06)',
        boxShadow: currentSign && isHigh ? '0 0 20px rgba(45,212,191,0.1)' : 'none',
        backdropFilter: 'blur(12px)',
      }}
    >
      <div className="flex items-center justify-between mb-2">
        <span className="text-[10px] font-bold tracking-widest text-slate-500 uppercase">
          Sinal Detectado
        </span>
        {currentSign && (
          <span
            className="text-xs font-bold px-2 py-0.5 rounded-full"
            style={{
              background: isHigh ? 'rgba(45,212,191,0.15)' : 'rgba(14,165,233,0.15)',
              color: isHigh ? '#2dd4bf' : '#38bdf8',
            }}
          >
            {pct}%
          </span>
        )}
      </div>

      {currentSign ? (
          <motion.div
            key={currentSign.label}
            initial={{ opacity: 0, y: 6 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.2 }}
          >
            <div className="flex items-center gap-3 mb-3">
              <div
                className="w-10 h-10 rounded-xl flex items-center justify-center text-xl flex-shrink-0"
                style={{ background: 'rgba(14,165,233,0.1)', border: '1px solid rgba(14,165,233,0.2)' }}
              >
                🤟
              </div>
              <div className="min-w-0 flex-1">
                <div className="text-[10px] text-slate-500 uppercase tracking-wider font-semibold mb-0.5">
                  {currentSign.label}
                </div>
                <div className="text-sm font-bold text-white leading-snug truncate" title={displayText ?? ''}>
                  {displayText}
                </div>
              </div>
            </div>
            <ConfidenceBar confidence={currentSign.confidence} />
          </motion.div>
        ) : (
          <motion.div
            key="waiting"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            className="flex items-center gap-3 py-1"
          >
            <div className="w-10 h-10 rounded-xl shimmer flex-shrink-0"
              style={{ background: 'rgba(255,255,255,0.04)' }} />
            <div className="flex-1">
              <div className="h-2.5 rounded-full w-3/4 mb-2 shimmer"
                style={{ background: 'rgba(255,255,255,0.04)' }} />
              <div className="h-2 rounded-full w-1/2 shimmer"
                style={{ background: 'rgba(255,255,255,0.04)' }} />
            </div>
          </motion.div>
        )}
    </div>
  );
};
